import { useEffect } from "react";
import Contact from "../components/Contact/Contact";
import Footerr from "../components/Footerr/Footerr";
import { Header } from "../components/shared";
import usePageMeta from "../../seo/usePageMeta";

function ContactPage() {
  usePageMeta({
    title: "Contact Us | Terces Solutions",
    description:
      "Get in touch with Terces Solutions to discuss your restaurant's operations, profitability, and growth. We respond within one business day.",
    path: "/Contact",
  });

  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="contact-page">
      <Header />
      <main className="contact-content">
        <Contact />
      </main>
      <Footerr />
    </div>
  );
}

export default ContactPage;
